<script>
export let season_instance;

export let msg_show;
export let msg_text;
export let msg_type;

export let successfully_submitted;



import { get } from 'svelte/store';
import { createForm } from 'svelte-forms-lib';
import * as yup from 'yup';
import { navigateTo, Navigate } from 'svelte-router-spa';

import { onMount } from 'svelte';


import FormFieldError from 'components/forms/FormFieldError.svelte';



const forms_api_url = app_.env.FORMS_API_URL;

const hcaptcha_site_key = app_.env.HCAPTCHA_SITE_KEY;


let captcha;



let loading = false;


const {
	form,
	errors,
	state,
	// handleBlur,
	handleChange,
	handleSubmit,
} = createForm({
	initialValues: {
		player_first_name: '',
		player_last_name: '',
		player_date_of_birth: '',
		current_team: '',
		current_team_level: '',
		position: '',
		city: '',
		province: '',
		parent_guardian_first_name: '',
		parent_guardian_last_name: '',
		parent_guardian_email: '',
		parent_guardian_phone_number: '',
	},
	validationSchema: yup.object().shape({
		player_first_name: yup
			.string()
			.required('Player first name required!'),
		player_last_name: yup
			.string()
			.required('Player last name required!'),
		player_date_of_birth: yup
			.string()
			.label('Player Date of Birth')
			.required('Player Date of birth required!'),
		current_team: yup
			.string()
			.label('Current team')
			.required('Current team required!'),
		current_team_level: yup
			.string()
			.oneOf([
				'AAA',
				'AA',
				'A',
				'B',
				'Recreational',
			])
			.label('Current team level')
			.required('Current team level required!'),
		position: yup
			.string()
			.oneOf([
				'Forward',
				'Defense',
				'Goalie',
			])
			.label('Positon')
			.required('Position required!'),
		city: yup
			.string()
			.label('City')
			.required('City required!'),
		province: yup
			.string()
			.label('Province')
			.required('Province required!'),
		parent_guardian_first_name: yup
			.string()
			.required('Parent/Guardian first name required!'),
		parent_guardian_last_name: yup
			.string()
			.required('Parent/Guardian last name required!'),
		parent_guardian_email: yup
			.string()
			.required('Parent/Guardian email required!'),
		parent_guardian_phone_number: yup
			.string()
			.required('Parent/Guardian phone required!'),
		'h-captcha-response': yup
			.string()
			.required(),
	}),

	onSubmit: values => {

		loading = true;

		// let body_data = JSON.stringify(values, removeEmptyStringAndNull);
		let body_data = JSON.stringify(values);

		submitForm(body_data).then(resp => {

			// alert('Saved!');
			msg_type = 'success';
			msg_show = true;
			msg_text = 'Thanks for submitting! You will be contacted by a team if you are needed!';

			successfully_submitted = true;

		}).catch(error => {

			msg_type = 'error';
			msg_show = true;

			alert('Error! Try again later.');

		}).finally(() => {

			loading = false;

		});

	}
});


async function submitForm(body_data) {

	const url = `https://ahg-serv-spring-free-agents.vercel.app/api/v1/spring-free-agents`;

	const resp = await fetch(url, {
		method: 'POST',
		body: body_data,
		headers: {
			'Content-Type': 'application/json',
		}
	});

	if (!resp.ok) {
		msg_text = result.detail;
		throw new Error('Error!');
	}

	return resp;
}



onMount(() => {
	// Append hCaptcha Script
	const loadhCaptcha = (callback) => {
		const existingScript = document.getElementById('hCaptcha');
		if (!existingScript) {
			const script = document.createElement('script');
			script.src = 'https://hcaptcha.com/1/api.js?recaptchacompat=off&render=explicit';
			script.id = 'hCaptcha';
			document.body.appendChild(script);
			script.onload = () => {
				if (callback) callback();
			};
		}
		if (existingScript && callback) callback();
	};

	// Render hCaptcha
	const injecthCaptcha = () => {
		hcaptcha.render(captcha, {
			theme: 'light',
			sitekey: hcaptcha_site_key,
			recaptchacompat: false,
			callback: (token) => {
				$form['h-captcha-response'] = token;
			},
			'expired-callback': (token) => {
				// $form['h-captcha-response'] = token;
			},
			'error-callback': (token) => {
				// $form['h-captcha-response'] = token;
			}
		});
	};
	// Run load and provide callback
	loadhCaptcha(() => {
		injecthCaptcha();
	});
});



</script>


<style>

form {

}

</style>



<form on:submit={handleSubmit}>

	<div class="field">

		<div class="control">

			<label>Player First Name (Required)</label>

			<input placeholder="Player First Name" class="input" type="text" id="player_first_name" name="player_first_name" on:change={handleChange} bind:value={$form.player_first_name}>

			{#if $errors.player_first_name}
				<FormFieldError detail={$errors.player_first_name} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Player Last Name (Required)</label>

			<input placeholder="Last Name" class="input" type="text" id="player_last_name" name="player_last_name" on:change={handleChange} bind:value={$form.last_name}>

			{#if $errors.last_name}
				<FormFieldError detail={$errors.last_name} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Player Date of Birth (Required)</label>

			<input placeholder="Player Date of Birth" class="input" type="date" id="player_date_of_birth" name="player_date_of_birth" step="1" on:change={handleChange} bind:value={$form.player_date_of_birth}>

			{#if $errors.player_date_of_birth}
				<FormFieldError detail={$errors.player_date_of_birth} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Current Team (Required)</label>

			<input placeholder="Current Team" class="input" type="text" id="current_team" name="current_team" on:change={handleChange} bind:value={$form.current_team}>

			{#if $errors.current_team}
				<FormFieldError detail={$errors.current_team} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Current Team Level (Required)</label>

			<div class="select is-fullwidth">

				<select bind:value={$form.current_team_level}>

					<option>Current Team Level</option>
					<option value="AAA">AAA</option>
					<option value="AA">AA</option>
					<option value="A">A</option>
					<option value="B">B</option>
					<option value="Recreational">Recreational</option>
					
				</select>

			</div>

			{#if $errors.current_team_level}
				<FormFieldError detail={$errors.current_team_level} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Position (Required)</label>

			<div class="select is-fullwidth">

				<select bind:value={$form.position}>

					<option>Position</option>
					<option value="Forward">Forward</option>
					<option value="Defense">Defense</option>
					<option value="Goalie">Goalie</option>
					
				</select>

			</div>

			{#if $errors.position}
				<FormFieldError detail={$errors.position} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>City (Required)</label>

			<input placeholder="City" class="input" type="text" id="city" name="city" on:change={handleChange} bind:value={$form.city}>

			{#if $errors.city}
				<FormFieldError detail={$errors.city} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Province (Required)</label>

			<div class="select is-fullwidth">

				<select bind:value={$form.province}>

					<option>Province</option>
					<option value="NB">NB</option>
					<option value="NS">NS</option>
					<option value="PEI">PEI</option>
					<option value="NL">NL</option>
					<option value="QC">QC</option>
					
				</select>

			</div>

			{#if $errors.province}
				<FormFieldError detail={$errors.province} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Parent/Guardian First Name (Required)</label>

			<input placeholder="Parent/Guardian First Name" class="input" type="text" id="parent_guardian_first_name" name="parent_guardian_first_name" on:change={handleChange} bind:value={$form.parent_guardian_first_name}>

			{#if $errors.parent_guardian_first_name}
				<FormFieldError detail={$errors.parent_guardian_first_name} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Parent/Guardian Last Name (Required)</label>

			<input placeholder="Parent/Guardian Last Name" class="input" type="text" id="parent_guardian_last_name" name="parent_guardian_last_name" on:change={handleChange} bind:value={$form.parent_guardian_last_name}>

			{#if $errors.parent_guardian_last_name}
				<FormFieldError detail={$errors.parent_guardian_last_name} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Parent/Guardian Email (Required)</label>

			<input placeholder="Parent/Guardian Email" class="input" type="text" id="parent_guardian_email" name="parent_guardian_email" on:change={handleChange} bind:value={$form.parent_guardian_email}>

			{#if $errors.parent_guardian_email}
				<FormFieldError detail={$errors.parent_guardian_email} />
			{/if}

		</div>

	</div>

	<div class="field">

		<div class="control">

			<label>Parent/Guardian Phone Num (Required)</label>

			<input placeholder="Parent/Guardian Phone Num" class="input" type="text" id="parent_guardian_phone_number" name="parent_guardian_phone_number" on:change={handleChange} bind:value={$form.parent_guardian_phone_number}>

			{#if $errors.parent_guardian_phone_number}
				<FormFieldError detail={$errors.parent_guardian_phone_number} />
			{/if}

		</div>

	</div>

	<br>

	<div class="field">

		<div class="control">

			<div bind:this={captcha} />

			{#if $errors['h-captcha-response']}
				<FormFieldError detail={"Prove you're not a bot!"} />
			{/if}

		</div>

	</div>

	<br>

	<div class="field">

		<div class="control">

			<button class="button is-blue is-fullwidth">
				<span>Submit Form</span>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!loading} style="margin-left: 0.75rem;"></i>
			</button>

		</div>

		<!-- <div class="control">

			<Navigate styles="form-card-link" to="/code/send-new">
				<span>Forgot Code or Email?</span>
			</Navigate>

		</div> -->

	</div>
	
</form>


